export type FileType = {
  file?: any;
  uri: string;
  type: 'image' | 'document';
};

export type UploadFileType = {
  file: File;
  uploadPercent: number;
};

export enum DropzoneStateEnums {
  IDLE = 'idle',
  UPLOAD = 'uploading',
  SUCCESS = 'upload-success',
}
